module.exports = __webpack_public_path__ + "img/93.878a6134.jpg";